"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Anchor = exports.ReadIcon = exports.ReadIconTransitionContainer = exports.ActionContainer = exports.Expiration = exports.Subtitle = exports.Title = exports.TextContainer = exports.Details = exports.Content = exports.Media = exports.MediaContainer = exports.MessageCard = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const __1 = require("..");
exports.MessageCard = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.neutral.n0};
  border: ${({ theme }) => theme.border.s100} solid ${({ theme }) => theme.colors.neutral.n100};
  border-radius: ${({ theme }) => theme.radius.s200};
  box-shadow: ${({ theme }) => theme.shadow.z1};
`;
exports.MediaContainer = styled_components_1.default.div `
  height: 100%;
  min-width: ${({ $variant }) => ($variant === __1.MessageCardVariant.PRIMARY ? '72px' : '50px')};
  padding-left: ${({ theme }) => theme.space.s100};
  display: flex;
  justify-content: center;
  align-items: center;
`;
exports.Media = styled_components_1.default.img `
  border: ${({ theme }) => theme.border.s100} solid transparent;
  border-radius: ${({ theme }) => theme.radius.s200};
  max-width: ${({ $variant }) => ($variant === __1.MessageCardVariant.PRIMARY ? '72px' : '50px')};
  max-height: ${({ $variant }) => ($variant === __1.MessageCardVariant.PRIMARY ? '72px' : '50px')};
`;
exports.Content = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  align-items: center;
`;
exports.Details = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  padding-top: ${({ theme, $variant }) => ($variant === __1.MessageCardVariant.PRIMARY ? theme.space.s200 : theme.space.s100)};
  padding-bottom: ${({ theme, $variant }) => ($variant === __1.MessageCardVariant.PRIMARY ? theme.space.s200 : theme.space.s100)};
  padding-left: ${({ theme }) => theme.space.s050};
  padding-right: 0;
  gap: ${({ theme, $variant }) => ($variant === __1.MessageCardVariant.PRIMARY ? theme.space.s100 : theme.space.s050)};
`;
exports.TextContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: ${({ theme }) => theme.space.s050};
`;
exports.Title = styled_components_1.default.span `
  ${({ theme, $variant }) => $variant === __1.MessageCardVariant.PRIMARY ? theme.typography.body.regularText : theme.typography.body.tinyTextRegular}
  color: ${({ theme }) => theme.colors.neutral.n800};
`;
exports.Subtitle = styled_components_1.default.span `
  ${({ theme }) => theme.typography.body.tinyTextRegular}
  color: ${({ theme }) => theme.colors.neutral.n700};
`;
exports.Expiration = styled_components_1.default.span `
  ${({ theme }) => theme.typography.body.tinyTextRegular}
  color: ${({ theme }) => theme.colors.neutral.n500};
`;
exports.ActionContainer = styled_components_1.default.div `
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.space.s300} ${({ theme }) => theme.space.s200} 0 ${({ theme }) => theme.space.s100};
`;
exports.ReadIconTransitionContainer = styled_components_1.default.div `
  &.read-icon-transition-enter {
    opacity: 0;
  }

  &.read-icon-transition-enter-active {
    opacity: 1;
    transition: opacity 500ms ease-in-out;
  }

  &.read-icon-transition-exit {
    opacity: 1;
  }

  &.read-icon-transition-exit-active {
    opacity: 0;
    transition: opacity 500ms ease-in-out;
  }
`;
exports.ReadIcon = styled_components_1.default.div `
  min-width: ${({ theme }) => theme.space.s100};
  min-height: ${({ theme }) => theme.space.s100};
  border: ${({ theme }) => theme.border.s100} solid transparent;
  background-color: ${({ theme }) => theme.colors.accent.base};
  border-radius: ${({ theme }) => theme.space.s400};
`;
exports.Anchor = styled_components_1.default.a `
  text-decoration: none;
`;
